<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="header-home" style="line-height: 1;">
                    Tell us about yourself and your business
                </div>
                <div class="flex-height-max flex-row">
                    <div class="content profile-content">
                        <div class="mb-3" style="font-size: 14px; line-height: 1.5;">
                            Before you can start using PPC Shield, we need to learn more about you and your business. This information will help us deliver a better user experience and personalized service.
                        </div>
                        <custom-input
                            name="user_name"
                            type="text"
                            v-model="user_name"
                            label="Name"
                            :errors="errors"
                        ></custom-input>

<!--                        <label for="job_title" class="main-form__label mt-1 w-100">
                            <input id="job_title"
                                   type="text"
                                   class="main-form__field"
                                   name="job_title"
                                   autocomplete="off">
                            <span class="main-form__field__title">
                                Job title
                            </span>
                            <span v-if="errors['job_title']" class="invalid-feedback">
                                <template><strong>{{ errors['job_title'][0] }}</strong></template>
                            </span>
                        </label>-->

                        <custom-input
                            name="phone_number"
                            type="text"
                            v-model="profile_info.phone"
                            label="Phone number (including the country prefix)"
                            :errors="errors"
                            :additional_handling="phone_mask"
                        ></custom-input>

                        <custom-input
                            name="who_do_you_manage_ads_for"
                            type="select"
                            v-model="selected_profile_type"
                            value_name="name"
                            label="Who do you manage ads for?"
                            :select_options="profile_types"
                            :errors="errors"
                        ></custom-input>

                        <custom-input
                            name="your_industry"
                            type="select"
                            v-model="selected_industry_type"
                            value_name="name"
                            label="Your industry"
                            :select_options="industry_types"
                            :errors="errors"
                        ></custom-input>

                        <custom-input
                            name="company_name"
                            type="text"
                            v-model="profile_info.company_name"
                            label="Company name / Website"
                            :errors="errors"
                        ></custom-input>

                        <custom-input
                            name="company_size"
                            type="select"
                            v-model="selected_company_size_type"
                            value_name="name"
                            label="Company size (number of employees)"
                            :select_options="company_size_types"
                            :errors="errors"
                        ></custom-input>

                        <button class="btn btn-primary mt-3 w-100" style="margin-bottom: 80px;" v-on:click="saveProfile">NEXT</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/undraw_Personal_site_re_c4bp.svg" alt="profile">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import VuePreloaders from 'vue-preloaders';
    import Infinite from '../shared/preloader.vue';
    Vue.use(VuePreloaders, {
        "component": Infinite,
        "overlayStyle": {
            "background": "rgba(0,0,0,.2)",
            "opacity": 1
        }
    });

    export default {
        props: ['progress_bar_percentage', 'progress_bar_text'],
        data: function () {
            return {
                user_name: '',
                user_email: '',
                industry_types: null,
                selected_industry_type: {id: '', name: ''},
                profile_types: null,
                selected_profile_type: '',
                company_size_types: null,
                selected_company_size_type: '',
                profile_info: {},

                errors: {name: ''},

                preloader: () => {},
            }
        },
        methods: {
            phone_mask(value){
                if(value === '' || value === '+') return '';
                else if(value[0] !== '+') return '+' + value;
                else return value;
            },
            getProfileData() {
                this.startPreloader();
                axios.post('/accountSettings/getProfile')
                    .then(info => {
                        const {data} = info;
                        this.profile_types = data.profile_types;
                        this.industry_types = data.industry_types;
                        this.company_size_types = data.company_size_types;
                        this.profile_info = data.profile;
                        this.user_email = data.user_email;
                        this.user_name = data.user_name;
                        if(data.profile.type_id) this.selected_profile_type = this.profile_types.filter((item) => item.id === data.profile.type_id)[0];
                        if(data.profile.company_size_id) this.selected_company_size_type = this.company_size_types.filter((item) => item.id === data.profile.company_size_id)[0];
                        if(data.profile.industry_type_id) this.selected_industry_type = this.industry_types.filter((item) => item.id === data.profile.industry_type_id)[0];
                        this.stopPreloader();
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.stopPreloader();
                    });
            },
            startPreloader() {
                this.preloader = this.$preloaders.open(/*{ options }*/);
            },
            stopPreloader() {
                this.preloader();
            },
            saveProfile(){
                this.startPreloader();
                axios.post('/setup/profileSave', {
                    'user_name': $('#user_name').val(),
                    'job_title': $('#job_title').val(),
                    'phone_number': $('#phone_number').val(),
                    'who_do_you_manage_ads_for': this.selected_profile_type.id,
                    'your_industry': this.selected_industry_type.id,
                    'company_name': $('#company_name').val(),
                    'company_size': this.selected_company_size_type.id,
                })
                    .then(info => {
                        if(info.status === 200){
                            window.location.href = info.data.route;
                        }
                        else if(info.status === 201){
                            this.errors = info.data.errors;
                        }
                        this.stopPreloader();
                    })
                    .catch(info => {
                        this.errors = info.response.data?.errors;
                        this.stopPreloader();
                    });
            },
        },
        mounted() {
            this.getProfileData();
        }
    }
</script>
